import * as Preact from "preact"
import * as Pixi from "@frog/source/pixi.js"
import Keyset from "@frog/source/utility/Keyset.js"

import "@frog/source/views/app/renderers/Loader.js" // TODO: just headless import?

Pixi.utils.skipHello()
Pixi.settings.SCALE_MODE = Pixi.SCALE_MODES.NEAREST
Pixi.SCALE_MODES.DEFAULT = Pixi.SCALE_MODES.NEAREST

/////////////
// EXPORT //
///////////

import "./PixiRenderer.view.less"

export default class PixiRenderer {
    render() {
        // if(loader != undefined
        // && loader.isDoing == true
        // && loader.isDone != true) {
        //     return (
        //         <div class="PixiRenderer" id="pixi">
        //             <div class="Progress">
        //                 {Math.round(loader.progress) + "%"}
        //             </div>
        //         </div>
        //     )
        // }
        update(this.props.viewmodels)
        return (
            <div class="PixiRenderer" id="pixi"/>
        )
    }
    componentDidMount() {
        document.getElementById("pixi").appendChild(app.view)
    }
}

////////////////
// RESOURCES //
//////////////

const resources = [
    // {"file": require("@frog/source/assets/images/blocks/block.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/assets/images/blocks/block-alt.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/assets/images/blocks/half-block.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/assets/images/blocks/half-block-alt.png"), "defaultAnchor": {"x": 0.5, "y": 1}},

    // {"file": require("@frog/source/images/frog.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/shoebill.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/half-block-edge-east.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/half-block-edge-south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/half-block-edge-north.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/half-block-edge-west.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-ramp.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-ramp-alt.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/south-ramp.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/south-ramp-alt.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/red.range.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/blue.range.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/redyellow.range.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/blue-range-east-ramp.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/red-range-east-ramp.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/blue-range-south-ramp.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/red-range-south-ramp.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/arrow.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/fire-dragon-1.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/fire-dragon-2.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/ground-dragon-1.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/ground-dragon-2.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/water-dragon-1.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/water-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/ground-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/fire-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/metal-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/grass-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/lightning-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/normal-dragon.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/blob.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/tamer.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/north.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/west.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/west-north.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/west-south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/west-east.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-north.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/north-south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/south-ramp.north-south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/south-ramp.north.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/south-ramp.south.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-ramp.west-east.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-ramp.west.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/east-ramp.east.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/cliff.north.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/cliff.west.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": require("@frog/source/images/cross.png"), "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": "https://frog-tactics.s3-us-west-2.amazonaws.com/assets/images/blocks/block-alt.png", "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": "https://frog-tactics.s3-us-west-2.amazonaws.com/assets/images/blocks/block.png", "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": "https://frog-tactics.s3-us-west-2.amazonaws.com/assets/images/blocks/half-block-alt.png", "defaultAnchor": {"x": 0.5, "y": 1}},
    // {"file": "https://frog-tactics.s3-us-west-2.amazonaws.com/assets/images/blocks/half-block.png", "defaultAnchor": {"x": 0.5, "y": 1}},
]

// import units from "@frog/source/data/units.js"
// Object.values(units["all"]).forEach((unit) => {
//     if(unit.image != undefined) {
//         resources.push({"file": unit.image, "defaultAnchor": {"x": 0.5, "y": 1.25}})
//     }
// })

const loader = {}
const Loader = {"resources": {}}
// const loader = new Pixi.Loader()
// // loader.onProgress.add(function() {
// //     console.log(...arguments)
// // })
// // loader.onLoad.add(function() {
// //     console.log("onLoad", ...arguments)
// // })
// if(resources.length > 0) {
//     loader.isDoing = true
//     loader.add(resources.map((resource) => resource.file)).load(function() {
//         resources.forEach((resource) => {
//             if(resource.defaultAnchor != undefined
//             && loader.resources[resource.file] != undefined
//             && loader.resources[resource.file].texture != undefined) {
//                 loader.resources[resource.file].texture.defaultAnchor.x = resource.defaultAnchor.x
//                 loader.resources[resource.file].texture.defaultAnchor.y = resource.defaultAnchor.y
//             }
//         })
//         loader.isDone = true // this also gates the default anchors being set.
//     })
// }

const textures = {}
const anchors = {}
// anchors[require("@frog/source/images/healthbar-tick-empty.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/healthbar-tick.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/healthbar-tick-danger.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/dot.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/shadowdot.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/swirl.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/bigswirl.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/damage.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Fire.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Water.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Ground.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Grass.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Metal.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Lightning.png").default] = {"x": 0.5, "y": 0.5}
// anchors[require("@frog/source/images/elements/Neutral.png").default] = {"x": 0.5, "y": 0.5}
// anchors["unit"] = {"x": 0.5, "y": 1.25}
// anchors[require("@frog/source/images/damage/poor-damage.png").default] = {"x": 0.5, "y": 1}
// anchors[require("@frog/source/images/damage/normal-damage.png").default] = {"x": 0.5, "y": 1}
// anchors[require("@frog/source/images/damage/great-damage.png").default] = {"x": 0.5, "y": 1}

anchors[require("@frog/source/images/ld47/characterUnit2_hook.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/ld47/characterUnit2_chain.png").default] = {"x": 0.5, "y": 0.5}
anchors[require("@frog/source/images/ld47/characterUnit4_swirl.png").default] = {"x": 0.5, "y": 0.5}
////////////////
// RENDERING //
//////////////

import sizes from "@frog/source/data/sizes.js"

const app = new Pixi.Application({
    "width": sizes.canvas.width,
    "height": sizes.canvas.height,
    "transparent": true,
})

app.stage.sprites = {} // key set!
// document.getElementById("frame").appendChild(app.view)
// window.pixi = app

// const PALETTE_IMAGES = {
//     "blue": require("assets/images/blue.palette.png"),
//     "yellow": require("assets/images/yellow.palette.png"),
//     "red": require("assets/images/red.palette.png"),
//     "green": require("assets/images/green.palette.png"),
// }
function update(viewmodels) {
    // TODO: up-front loading!! just what is needed
    // if(Loader.isDone != true) {
    //     console.log(Math.round(Loader.progress) + "%")
    //     return
    // }

    updatePixi(viewmodels)

    if(viewmodels["camera"] != undefined
    && viewmodels["camera"].position != undefined) {
        const camera = viewmodels["camera"]
        app.stage.x = camera.position.x
        app.stage.y = camera.position.y
        // app.stage.position.x = camera.position.x - (app.renderer.width / 2) + 2 // - (Point.TILE / 2)
        // app.stage.position.y = camera.position.y - (app.renderer.height / 2) // - (Point.TILE / 2)
        // // TODO: this should be done in the viewmodel!!
        // // if(camera.nudge != undefined) {
        // //     app.stage.position.x += camera.nudge.x || 0
        // //     app.stage.position.y += camera.nudge.y || 0
        // // }
        // app.stage.position.x *= -1
        // app.stage.position.y *= -1

        // // TODO: How to handle camera zoom and pan
        // app.view.style.transform = "scale(" + camera.zoom + ")"
    }
}

function updatePixi(viewmodels) {
    // TODO: support embedded viewmodels in arrays of arrays of viewmodels

    // Deleting
    Keyset.forEach(app.stage.sprites, (sprite, key) => {
        if(viewmodels[sprite.key] == undefined) {
            delete app.stage.sprites[sprite.key]
            app.stage.removeChild(sprite)
        }
    })

    // Creating and Updating
    Keyset.forEach(viewmodels, (viewmodel) => {
        if(app.stage.sprites[viewmodel.key] == undefined) {
            const sprite = createPixiSprite(viewmodel)
            app.stage.addChild(sprite)
            app.stage.sprites[sprite.key] = sprite
        }

        // app.stage.sprites[viewmodel.key] =
        updatePixiSprite(viewmodel, app.stage.sprites[viewmodel.key])
    })

    // Z-indexing
    app.stage.sortChildren()
}

function createPixiSprite(viewmodel) {
    let sprite = undefined
    // TODO: Combine this with the updatePixiSprite so it can JIT create it.
    // TODO: is radius really the trigger for generic graphics?
    if(viewmodel.radius != undefined) {
        // sprite = new Pixi.Graphics()
    } else {
        sprite = new Pixi.Sprite()
    }

    sprite.key = viewmodel.key
    return sprite
}

function updatePixiSprite(viewmodel, sprite) {
    if(viewmodel == undefined
    || sprite == undefined) {
        return
    }
    if(viewmodel.key == "camera") {
        return
    }
    // if(viewmodel instanceof Array) {
    //     return viewmodel.map((_viewmodel) => {
    //         updatePixiSprite(pixi, _viewmodel)
    //     })
    // }
    // if(viewmodel.type == "Line") {
    //     // Can we somehow represent this with
    //     // something more efficient like a low
    //     // level mesh??
    //     const graphics = new Pixi.Graphics()
    //     const a = viewmodel.points[0]
    //     const b = viewmodel.points[1]
    //     graphics.lineStyle(20, 0xf0ead6)
    //     graphics.moveTo(a.x, a.y)
    //     graphics.lineTo(b.x, b.y)
    //     graphics.zIndex = 1000000
    //     pixi.addChild(graphics)
    //     return
    // }
    // if(viewmodel.type == "Text") {
    //     const text = new Pixi.Text(viewmodel.text, {"fontFamily": "Arial", "fontSize": 48, "fill": 0x000000})
    //     text.anchor.x = 0.5
    //     text.anchor.y = 0.5
    //     text.position.x = viewmodel.position.x
    //     text.position.y = viewmodel.position.y
    //     text.position.z = viewmodel.position.z
    //     text.zIndex = 1000000
    //     pixi.addChild(text)
    //     return
    // }
    // if(sprite instanceof Pixi.Graphics) {
    //     if(viewmodel.radius != undefined) {
    //         sprite.clear()
    //         // const graphics2 = new Pixi.Graphics()
    //         sprite.beginFill(viewmodel.color)
    //         // graphics2.beginFill(viewmodel.color)
    //         sprite.lineStyle(0)
    //         // graphics2.lineStyle(1, 0x543935)
    //         // graphics2.lineStyle(1, 0xfeeae0)
    //         sprite.drawCircle(0, 0, viewmodel.radius)
    //         sprite.endFill()
    //     }
    // }

    //////////////
    // TEXTURE //
    ////////////

    if(sprite instanceof Pixi.Sprite) {
        if(viewmodel.image != undefined) {
            viewmodel.image = viewmodel.image ? viewmodel.image.default || viewmodel.image : viewmodel.image // GROSS GROSS GROSS WHY ISN'T WEBPACK DOING THIS ANYMORE NOW THAT BABEL ISN'T PARSING IT?
            textures[viewmodel.image] = textures[viewmodel.image] || Pixi.Texture.from(viewmodel.image)
            sprite.texture = textures[viewmodel.image] // Loader.resources[viewmodel.image].texture

            // sprite.anchor = sprite.texture.defaultAnchor
            sprite.anchor.x = 0.5
            sprite.anchor.y = 1
            if(anchors[viewmodel.type] != undefined) {
                sprite.anchor.x = anchors[viewmodel.type].x || sprite.anchor.x
                sprite.anchor.y = anchors[viewmodel.type].y || sprite.anchor.y
            }
            if(anchors[viewmodel.image] != undefined) {
                sprite.anchor.x = anchors[viewmodel.image].x || sprite.anchor.x
                sprite.anchor.y = anchors[viewmodel.image].y || sprite.anchor.y
            }
        }
        if(viewmodel.anchor != undefined) {
            if(viewmodel.anchor.x !== undefined) sprite.anchor.x = viewmodel.anchor.x
            if(viewmodel.anchor.y !== undefined) sprite.anchor.y = viewmodel.anchor.y
        }

        // // COPIED FROM BOMBERBRO
        // if(Loader.resources[viewmodel.image] == undefined) {
        //     console.log("Could not find image resource in loader.")
        //     return
        // }
        // sprite.texture = Loader.resources[viewmodel.image].texture
        // sprite.anchor = sprite.texture.defaultAnchor
        // // ....
    }

    ///////////////
    // POSITION //
    /////////////

    // sprite.position.x = Math.round(sprite.position.x)
    // sprite.position.y = Math.round(sprite.position.y)
    if(viewmodel.position != undefined) {
        sprite.position.x = viewmodel.position.x
        sprite.position.y = viewmodel.position.y
        sprite.zIndex = viewmodel.position.stack

        // TODO: how to schema-ify the z-index. In position?
        // sprite.zIndex = (viewmodel.position.y * 10)
        // // BECAUSE GRAPHICS DON'T HAVE ... ANCHORS
        // if(sprite instanceof Pixi.Graphics) {
        //     sprite.position.y -= Point.TILE / 2
        // }
        // if(viewmodel.stack != undefined) {
        //     sprite.zIndex = viewmodel.stack
        // }
    }
    if(viewmodel.nudge != undefined) {
        // TODO: why isn't this in a view model...
        sprite.position.x += viewmodel.nudge.x || 0
        sprite.position.y += viewmodel.nudge.y || 0
    }
    // sprite.position.x = entity.position.x
    // sprite.position.y = entity.position.y
    // sprite.zIndex = entity.position.stackture.from(entity.image)

    /////////////////
    // DECORATION //
    ///////////////

    sprite.angle = viewmodel.rotation || 0
    // sprite.pivot.x = sprite.width / 2
    // sprite.pivot.y = sprite.height / 2
    sprite.scale.x = (viewmodel.scale ? viewmodel.scale.x || 1 : 1) * (viewmodel.direction == "left" ? -1 : +1)
    sprite.scale.y = (viewmodel.scale ? viewmodel.scale.y || 1 : 1)

    if(viewmodel.opacity !== undefined) {
        sprite.alpha = viewmodel.opacity
        // TODO: include blend mode options??
        // sprite.blendMode = Pixi.BLEND_MODES.MULTIPLY
    }
    if(viewmodel.imagecolor != undefined
    && PALETTE_IMAGES[viewmodel.imagecolor] != undefined) {
        sprite.filters = sprite.filters || []
        sprite.filtering = sprite.filtering || {}
        if(sprite.filtering.imagecolor == undefined) {
            sprite.filtering.imagecolor = new PaletteSwapFilter(PALETTE_IMAGES[viewmodel.imagecolor])
            sprite.filters.push(sprite.filtering.imagecolor)
        }
    }
    if(viewmodel.whiteout != undefined) {
        sprite.filters = sprite.filters || []
        sprite.filtering = sprite.filtering || {}
        if(sprite.filtering.colormatrix == undefined) {
            sprite.filtering.colormatrix = new Pixi.filters.ColorMatrixFilter()
            sprite.filters.push(sprite.filtering.colormatrix)
            // filter.blackAndWhite(false)
            // filter.browni(true)
            // filter.brightness(1, true)
            // filter.desaturate()
            // filter.hue(90, true)
            // filter.kodachrome(true)
            // filter.lsd(true)
            // filter.polaroid(true)
            // filter.technicolor(true)
            // filter.vintage(true)
        }
        sprite.filtering.colormatrix.alpha = viewmodel.whiteout || 0
        sprite.filtering.colormatrix.contrast(10, true)
    }
    if(viewmodel.blur != undefined) {
        sprite.filters = sprite.filters || []
        sprite.filtering = sprite.filtering || {}
        if(sprite.filtering.blurfilter == undefined) {
            sprite.filtering.blurfilter = new Pixi.filters.BlurFilter()
            sprite.filters.push(sprite.filtering.blurfilter)
        }
        sprite.filtering.blurfilter.blur = viewmodel.blur
    }
    if(viewmodel.outline != undefined) {
        sprite.filters = sprite.filters || []
        sprite.filtering = sprite.filtering || {}
        if(sprite.filtering.outline == undefined) {
            sprite.filtering.outline = new Pixi.filters.OutlineFilter(viewmodel.outline.thickness, viewmodel.outline.color)
            sprite.filters.push(sprite.filtering.outline)
        }
        sprite.filtering.outline.thickness = viewmodel.outline.thickness
        sprite.filtering.outline.color = viewmodel.outline.color
    } else if(sprite.filtering != undefined && sprite.filtering.outline != undefined) {
        sprite.filtering.outline.thickness = 0
        sprite.filtering.outline.color = 0
    }
    if(viewmodel.tint == undefined) {
        sprite.tint = 0xFFFFFF
    } else {
        sprite.tint = viewmodel.tint
    }
    if(viewmodel.grayscale != undefined) {
        sprite.filters = sprite.filters || []
        sprite.filtering = sprite.filtering || {}
        if(sprite.filtering.grayscale == undefined) {
            sprite.filtering.grayscale = new Pixi.filters.ColorMatrixFilter()
            sprite.filtering.grayscale.greyscale(0.33, false)
            sprite.filters.push(sprite.filtering.grayscale)
        }
        sprite.filtering.grayscale.alpha = viewmodel.grayscale
    } else {
        if(sprite.filtering != undefined
        && sprite.filtering.grayscale != undefined) {
            sprite.filtering.grayscale.alpha = 0
        }
    }
    return sprite
}
